import { AppProps } from 'presentation/App';
import { useEffect } from 'react';
import { LuChevronLeft, LuInfo } from 'react-icons/lu';
import { useNavigate } from 'react-router-dom';
import { PRIVATE_ROUTES } from 'presentation/router/CONSTANTS';
import { EvaluateForm } from './components/EvaluateForm';
import { StepProgress } from './components/StepProgress';
import styles from './styles.module.scss';

const CU05602PageV2 = (props: AppProps) => {
    const navigate = useNavigate();

    useEffect(() => {
        document.querySelector('.ant-layout-content')?.scrollTo(0, 0);
    }, []);

    return (
        <div className={styles.page}>
            <nav className={styles.topNav}>
                <div
                    className={styles.navLeft}
                    onClick={() =>
                        navigate(`${PRIVATE_ROUTES.PATH}/${PRIVATE_ROUTES.SUB.CU_056_01}`)
                    }
                >
                    <LuChevronLeft className={styles.navBackIcon} />
                    <span className={styles.navBackText}>査定メニュー</span>
                </div>
                <h1 className={styles.navTitle}>かんたん査定</h1>
                <div className={styles.navSpacer} />
            </nav>

            <main className={styles.content}>
                <StepProgress currentStep={1} />

                <section className={styles.formCard}>
                    <h2 className={styles.formTitle}>物件の情報を教えてください</h2>
                    <p className={styles.formSubtitle}>
                        4つの項目を入力するだけ。わからない場合はだいたいで大丈夫です。
                    </p>
                    <EvaluateForm {...props} />
                </section>

                <div className={styles.infoNote}>
                    <LuInfo className={styles.infoNoteIcon} />
                    <p className={styles.infoNoteText}>
                        ここで入力した情報が外部に公開されることはありません。査定は完全無料です。
                    </p>
                </div>
            </main>
        </div>
    );
};

export default CU05602PageV2;
